// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-multiselect/dist/vue-multiselect.min.css
// module id = tLvy
// module chunks = 6